interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function UnitToggle<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className="inline-flex gap-0.5 bg-gray-100 rounded-md p-0.5">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-2 py-0.5 text-[11px] rounded transition-colors ${
            value === opt.value
              ? 'bg-white text-spi-green-dark font-medium shadow-sm'
              : 'text-spi-slate hover:text-spi-charcoal'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
